import { STORE_TYPES } from '../../config/tenantTypes';
import { rentalMenu } from './menu';
import { rentalRoutes } from './routes';

const RentalModule = {
  key: STORE_TYPES.BRIDAL_RENTAL,
  defaultPath: '/dashboard',
  menu: rentalMenu,
  routes: rentalRoutes,
};

export default RentalModule;
